export default {
  jsonString(value) {
    if (typeof value == 'string') {
      try {
        var obj = JSON.parse(value);
        if (typeof obj == 'object' && obj) {
          return true;
        } else {
          return false;
        }
      } catch (e) {
        return false;
      }
    }
    return false;
  }
}